export const QUERY_KEY = 'org_pref';
